exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbpx-input[data-v-9acb1b44]{margin-top:4px}.checkbox-label[data-v-9acb1b44]{text-align:left;cursor:pointer;margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9acb1b44","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/form-elements/CheckboxItem.vue
// module id = 584
// module chunks = 38